import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Navigate, useNavigate } from 'react-router'
import { useSearchParams } from 'react-router-dom'
import { Element } from '../../common/html/element'
import { Icon } from '../../common/html/icon'
import { selectUserType } from '../../layout/store/slice'
import { COMPONENTS } from '../../routers/constants'
import { COMPLETED_STATUS } from '../../userManagement/subscriptionPayment/orderManagement/constants'
import { selectData } from '../../userManagement/subscriptionPayment/orderManagement/orderDetail/store/slice'
import { getDetailOrderThunk } from '../../userManagement/subscriptionPayment/orderManagement/orderDetail/store/thunk'
import { USER_TYPE } from '../../utils/authorization'
import { TYPE_STATUS_ORDER } from '../constant'
import classes from '../index.module.scss'
import { selectPopularCompany, selectSimilarCompany } from '../store/slice'
import { getMostPopularCompanies, getSimilarCompanies } from '../store/thunk'
import CompanyList from './CompanyList'

const OrderConfirmation = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [params] = useSearchParams()

  const paymentStatus = params.get('PaymentStatus')
  const step = params.get('step')
  const transactionCode = params.get('TransactionCode')
  const orderId = params.get('OrderId')

  const orderDetail = useSelector(selectData)
  const dataSimilarCompany = useSelector(selectSimilarCompany)
  const dataPopularCompany = useSelector(selectPopularCompany)
  const userType = useSelector(selectUserType)
  const locale = useSelector((state) => state.i18n.locale)

  const navigateDashboard = () => {
    navigate(`${COMPONENTS.dashboard.components.dashboard.route}`)
  }

  const navigateManagement = () => {
    navigate(
      `${COMPONENTS.userManagement.components.subscriptionPayment.components.orderDetail.route}?orderId=${orderId}`,
    )
  }

  useEffect(() => {
    dispatch(getDetailOrderThunk({ Id: orderId }))
  }, [locale])

  const renderContent = () => {
    return (
      <>
        <Element
          style={{ backgroundColor: '#FFFFFF' }}
          className={classes.orderConfirmationContainer}
        >
          <Element
            className={classes.content}
            style={{ backgroundColor: '#F3F3F3' }}
          >
            <div>
              {paymentStatus !== TYPE_STATUS_ORDER.PENDING && (
                <Element style={{ color: '#191D25' }} className="fw600">
                  <Translate
                    value={`cartAndOrders.orderConfirmation.${
                      paymentStatus === TYPE_STATUS_ORDER.PAID
                        ? 'success'
                        : paymentStatus === TYPE_STATUS_ORDER.CHECKING
                        ? 'check'
                        : 'payment'
                    }`}
                  />
                </Element>
              )}

              <div className={`${classes.mt4} dFlex`}>
                <div>
                  <Icon
                    className="icon-tick-circle-fill"
                    style={{ color: '#32BEA6', fontSize: 15, marginRight: 4 }}
                  />
                </div>
                <div>
                  {orderDetail?.status === COMPLETED_STATUS ? (
                    <Translate value="cartAndOrders.orderConfirmation.completed" />
                  ) : (
                    <Translate value="cartAndOrders.orderConfirmation.process" />
                  )}
                  <br />
                  <Translate value="cartAndOrders.orderConfirmation.noti" />
                </div>
              </div>
              <div className={classes.mt12}>
                <Element style={{ color: '#191D25' }} className="fw600">
                  <Translate value="cartAndOrders.orderConfirmation.thanks" />
                </Element>
                <div className={classes.mt4}>
                  <Translate value="cartAndOrders.orderConfirmation.clickOn" />
                </div>
              </div>
            </div>
            <div>
              <Element
                className={classes.button}
                style={{ backgroundColor: '#2C73E8', color: '#FFFFFF' }}
                onClick={navigateDashboard}
              >
                <Translate
                  value="cartAndOrders.orderConfirmation.goDashboard"
                  style={{ padding: '0 8px' }}
                />
              </Element>
              <div className={classes.mt12}>
                <Element
                  className={classes.button}
                  style={{ backgroundColor: '#0553A5', color: '#FFFFFF' }}
                  onClick={navigateManagement}
                >
                  <Translate
                    value="cartAndOrders.orderConfirmation.orderManage"
                    style={{ padding: '0 8px' }}
                  />
                </Element>
              </div>
            </div>
          </Element>
          <div className="flex1">
            <div className="h100 flexColumn">
              <Element
                className={`fw500 ${classes.pdb8} ${classes.pdt8}`}
                style={{ fontSize: 20, color: '#9C9C9C' }}
              >
                <Translate value="cartAndOrders.orderConfirmation.maybeLike" />
              </Element>

              <div className={`${classes.contentContainer} flex1`}>
                <CompanyList
                  title="cartAndOrders.orderConfirmation.similarCompany"
                  items={dataSimilarCompany}
                  tooltipContent="cartAndOrders.orderConfirmation.tooltipSimilar"
                  isSimilar
                  keyLoading="getSimilarCompanies"
                />
                <CompanyList
                  title="cartAndOrders.orderConfirmation.theMostCompany"
                  items={dataPopularCompany}
                  tooltipContent="cartAndOrders.orderConfirmation.tooltipMostPopular"
                  keyLoading="getMostPopularCompanies"
                />
              </div>
            </div>
          </div>
        </Element>
      </>
    )
  }

  useEffect(() => {
    dispatch(
      getSimilarCompanies({
        TransactionCode: transactionCode,
      }),
    )
    dispatch(getMostPopularCompanies())
  }, [locale])

  if (!paymentStatus || [USER_TYPE.TRIAL].includes(userType.userTypeId)) {
    return <Navigate to={`${COMPONENTS.cartAndOrders.route}?step=1`} />
  }

  return (
    <>
      {!!step ? (
        <>{renderContent()}</>
      ) : (
        <>
          <Element
            className="dFlex justifyContentCenter"
            style={{
              backgroundColor: '#F3F3F3',
              minHeight: '100%',
            }}
          >
            {renderContent()}
          </Element>
        </>
      )}
    </>
  )
}

export default OrderConfirmation
